export default "__VITE_ASSET__ICz5vrY2__"